import React, { Component } from 'react';
//import * as PIXI from 'pixi.js';


//let NEXT_SPRITE_ID = 0;
const PIXI = window.PIXI;

class Dot
{
  constructor(renderer)
  {
      this.renderer = renderer;
      this.xVelocity = Math.random() * 0.5 - 0.25;
      this.yVelocity = Math.random() * 0.5 - 0.25;
  }

  update()
  {
    if(this.x < 0 || this.x > this.renderer.width)
      this.xVelocity *= -1;

    if(this.y < 0 || this.y > this.renderer.height)
        this.yVelocity *= -1;

    this.x += this.xVelocity;
    this.y += this.yVelocity;
  }
}

class PartnersGame
{

  constructor(canvasContainer)
  {
    this.bullets = {};
    this.scanRadius = 80;
    this.mouseRadius = 80;

    this.lineColor = 0x8d6eaa;

    this.canvasContainer = canvasContainer;
    this.renderer = PIXI.autoDetectRenderer(window.innerWidth, canvasContainer.getBoundingClientRect().height, null, true);
    this.canvasContainer.appendChild(this.renderer.view);


    /*PIXI.loader
    .add('assets/invaders/sprites.json')
    .add('grad1', 'assets/gradients/grad1.png')
    .add('photo', 'assets/photo.png')
    .load(() => this.setup());*/

    this.setup();
  }

  setup()
  {
    this.stage = new PIXI.Container();

    this.actionStage = new PIXI.Graphics();
    this.stage.addChild(this.actionStage);
    this.stage.interactive = true;
    this.stage.mousemove = (data) => this.mousemove(data);

    this.stage.on("pointerdown", (data) => this.mousemove(data));

    this.addDots();

    PIXI.ticker.shared.add(() => this.render());

    window.addEventListener('resize', (event) => this.resizeStage(event));
    //window.addEventListener("orientationchange", (event) => this.resizeStage(event));
  }


  mousemove(data)
  {
    if(data.target == null)
    {
      this.lastMousePosition = null;
    }
    else
    {
      this.lastMousePosition = data.data.global;
    }
  }


  resizeStage(event)
  {
    //this.renderer.view.style.width = window.width;

    this.renderer.view.style.display = "none";
    setTimeout(() => {
      this.renderer.view.style.display = "";
      this.renderer.resize(window.innerWidth, this.renderer.height);
      this.clearBackground();
    }, 100);

  }


  addDots()
  {
    this.dots = [];

    for(let i = 0; i < 200; i++)
    {
      this.dots.push(this.addDot());
    }
  }

  addDot()
  {
    let dot = new Dot(this.renderer);

    dot.x = Math.random() * this.renderer.width;
    dot.y = Math.random() * this.renderer.height;

    return dot;
  }

  clearBackground()
  {
    this.actionStage.clear();
    this.actionStage.nativeLines = true;
    this.actionStage.beginFill(0xffffff, 1);
    this.actionStage.drawRect(0, 0, this.renderer.width, this.renderer.height);
    this.actionStage.endFill();
  }

  render()
  {
  //  this.actionStage.beginFill(0xffffff, 1);
  //  this.actionStage.drawRect (0, 0, this.renderer.width, this.renderer.height);

  let boundingBox = this.canvasContainer.getBoundingClientRect();
  if(boundingBox.bottom < 0 || boundingBox.top > window.innerHeight)
    return;

    this.clearBackground()

    for(let i = 0; i < this.dots.length; i++)
    {
      let dot = this.dots[i];

      if(this.lastMousePosition != null)
      {
        let length = Math.sqrt(Math.pow(this.lastMousePosition.x - dot.x, 2) + Math.pow(this.lastMousePosition.y - dot.y, 2));
        //if(length < 200 && length > 10)
        if(length < this.mouseRadius)
        {
          //dot.xVelocity = -(this.lastMousePosition.x - dot.x) / length;
          //dot.yVelocity = -(this.lastMousePosition.y - dot.y) / length;
          this.actionStage.lineStyle(1, this.lineColor, (1 - length / this.mouseRadius) / 2);
          this.actionStage.moveTo(dot.x, dot.y);
          //let angle = Math.atan2(this.lastMousePosition.y - dot.y, this.lastMousePosition.x - dot.x);
          //this.actionStage.quadraticCurveTo(dot.x + Math.cos(angle + Math.PI) * length / 2, dot.y + Math.sin(angle * Math.PI) * length / 2, this.lastMousePosition.x, this.lastMousePosition.y)
          this.actionStage.lineTo(this.lastMousePosition.x, this.lastMousePosition.y);
          this.actionStage.endFill();
        }
      }



      dot.update();

      this.actionStage.lineStyle(1, this.lineColor, 1);
      //this.actionStage.moveTo(dot.x, dot.y, 1);
      //this.actionStage.lineTo(dot.x+0.1, dot.y+0.1, 1);
      this.actionStage.drawRect(dot.x - 0.5, dot.y - 0.5, 1, 1);
      this.actionStage.endFill();

      //this.actionStage.beginFill(0x0, 1);
      //his.actionStage.drawRect (0, 0, this.renderer.width, this.renderer.height);

      for(let j = i + 1; j < this.dots.length; j++)
      {
          let nextDot = this.dots[j];
          let length = Math.sqrt(Math.pow(nextDot.x - dot.x, 2) + Math.pow(nextDot.y - dot.y, 2));
          if(length < this.scanRadius)
          {

            this.actionStage.lineStyle(1, this.lineColor, (1 - length / this.scanRadius) / 2 );
            this.actionStage.moveTo(dot.x, dot.y);
            this.actionStage.lineTo(nextDot.x, nextDot.y);
            this.actionStage.endFill();
          }
      }
    }

    this.renderer.render(this.stage);
  }
}

class Partners extends Component
{
  componentDidMount()
  {
      //Setup PIXI Canvas in componentDidMount
      this.game = new PartnersGame(this.refs.partnerCanvas);
   }

  render()
  {
    return (
      <div className="backgroundCanvas" id="backgroundPartner" ref="partnerCanvas"></div>
    )
  }
}

export default Partners;



// WEBPACK FOOTER //
// ./src/backgrounds/Partners.js